import React from "react";
import "./PolicyCard.css";
import { Markup } from "interweave";

const PolicyCard = ({ title, title_bn, details_bn, description, currentLang }) => {
  console.log("PolicyCard Props:", { title, title_bn, details_bn, description, currentLang });
  return (
    <div>
      <div className="left-col-box mt-3 rounded pb-3">
        <h5 className="text-center text-warning py-4 ">{currentLang==='en' ? description[0]?.title : description[0]?.title_bn}</h5>
        {description &&
          description.map((data, i) => (
            <div className="bg-about mx-3 p-2 text-light  rounded" key={i}>
              <b>
                <Markup key={i} content={currentLang==='en' ? data.title : data.title_bn}></Markup>
              </b>
              <br></br>
              <Markup key={i} content={currentLang==='en' ? data.details : data.details_bn}></Markup>
            </div>
          ))}
      </div>
    </div>
  );
};

export default PolicyCard;
